export default "__VITE_PUBLIC_ASSET__34540629__"